import { render, staticRenderFns } from "./HealthOverview.vue?vue&type=template&id=0295805a&"
import script from "./HealthOverview.vue?vue&type=script&lang=js&"
export * from "./HealthOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports